import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { combineLatest } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-re-allocation',
  templateUrl: './re-allocation.component.html',
  styleUrls: ['./re-allocation.component.scss']
})
export class ReAllocationComponent implements OnInit {


  reasonType: string = "";
  assocType: string = "";
  branchType: string = "";

  // @Input() isAssocInfo;
  // @Input() isOfficerAssocInfo;
  @Input() isorderDetailsRes;
  @Input() isSendStatus;
  @Input() orderId;
  @Input() tenantCode;
  @Input() orgCode;
  @Input() role;
  ForceAllocationOffList:any;
  @ViewChild('ForceAllocationOfficers') tenantSelect: NgSelectComponent;


  msg:string ="";
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  disableSelectBtn: Boolean = false
  reasonOptions = [
    { label: 'Change In Officer As Per CX Request', value: 'Change In Officer As Per CX Request' },
    { label: 'Change In Officer As Per CX Request - OTP Not Received', value: 'Change In Officer As Per CX Request - OTP Not Received' },
    { label: 'Different Officers Assigned To The Same Family', value: 'Different Officers Assigned To The Same Family' },
    { label: 'Load Optimization', value: 'Load Optimization' },
    { label: 'Mechanical Breakdown', value: 'Mechanical Breakdown' },
    { label: 'Nearest Officer Availability', value: 'Nearest Officer Availability' },
    { label: 'No Show By Officer', value: 'No Show By Officer' },
    { label: 'Officer Shift Changed', value: 'Officer Shift Changed' },
    { label: 'Self Allocation Did Not Happened', value: 'Self Allocation Did Not Happened' },
    { label: 'UPSELL Orders', value: 'UPSELL Orders' },
    { label: 'Wrong Booking Done', value: 'Wrong Booking Done' },
    { label: 'Wrong Pincode Updation', value: 'Wrong Pincode Updation' },
  ];
  qualification=['BAMS','BDS','DCH','DDVL','DGO',
    'DM','DNB','FRCA','Fellowship','FRCR','FRCS','MBBS','MD','MS',
    'MCH','MDS','MRCOG','MRCP','MRCS','MRCPsych','MRCPCH','M.Sc','M.Phil','PhD','B.Sc',
    'Lamaze Certified Childbirth Educators (LCCE)','BFY','ACE','NIS','Reebok Certified Personal Trainer',
    'P.G Diploma in Health Fitness','D. Ortho']
  isAssocData: any;
  branchInfo: any;
  officerList: any;
  assoc_data:any;
  officerAssocInfo: any;
  orderDetailsRes:any;
  issubCategory: Boolean = false;
  isTableView: Boolean = true;
  showreAllocateView: Boolean = false;
  hideAllocateView: Boolean = false;
  showAllocateView: Boolean = false;
  showReportsCompletedView: Boolean = false;
  constructor(

    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private fb:FormBuilder
  ) {}
  staff_Form!:FormGroup;
  ngOnInit(): void {
    // console.log(`isOfficerAssocInfo`,this.isOfficerAssocInfo["data"])
    // console.log(`isAssocData`,this.isAssocInfo["associates"])
    // console.log(`isAssocBranchData`,this.isAssocInfo["assocBranches"])
    // console.log(`isorderDetailsRes`,this.isorderDetailsRes[0]['order']['provider_info'][1])
    // console.log(`isSendStatus`,this.isSendStatus)
    // this.isAssocData = this.isAssocInfo["associates"];
    // this.officerList = this.isOfficerAssocInfo["data"];
    // this.officerAssocInfo = this.isOfficerAssocInfo;

    this.orderDetailsRes = this.isorderDetailsRes

      if(this.isSendStatus == 're-allocate'){
        this.showreAllocateView = true;
      }else if(this.isSendStatus == 'allocate'){
        this.showAllocateView = true;
      }else if(this.isSendStatus == 'reports'){
        this.showReportsCompletedView = true;
      }
      console.log(this.isSendStatus)
      if(this.isSendStatus == 'forceAllocate'){
        this.getForceAllocationOffList()
      }else if(this.isSendStatus == 'createOfficer'){
        this.getLanguagesList()
        this.getAssociatesList()
      }else{
        this.openReAllocateData()
      }
      // if (this.isorderDetailsRes[0]['order']['provider_info'][1]['officer_id'] == "") {
      //     this.hideAllocateView = true;
      // }
      this.staff_Form = this.fb.group({
        // selectedTest:['',Validators.required],
        associateName: ['',Validators.required],
        branchName:['',Validators.required],
        // department:[''],
        firstName:['',Validators.required],
        lastName:['',Validators.required],
        gender:['',Validators.required],
        mobile: ['',
        Validators.compose([
          Validators.required,
            // ValidationUtil.phoneNumberValidator,
          ]),
        ],
        email: ['',Validators.compose([
          Validators.required,
          // ValidationUtil.emailValidator,
          ]),
        ],
        lanSpoken:['',Validators.required],
        yrExp:['',Validators.required],
        degree:['',Validators.required],
        // staffGroup: this.fb.array([]),
     })


  }
  
  get f() {return this.staff_Form.controls}
  languagesList:any=[]
  getLanguagesList(){
    let payload={
     "entity": "languageMaster",
    "colNames": "status",
    "colValues": "1"
    }
    this.omsServiceService.languagesList(payload).subscribe((res:any)=>{
      console.log(res);
      if(res && res.status == 'success'){
        this.languagesList =res.data;
      }
    })
  }
  selecetdAssociateCode:any;
  selectedBranchCode:any
  branchList:any
  selectAssociateList(event:any){
    let selectedData = event
    this.branchList=[]
    if (selectedData != undefined && selectedData != null && selectedData != '') {
      this.selecetdAssociateCode=event.id
      this.branchList=event.branch
      if(this.branchList.length ==1){
        this.staff_Form.patchValue({
          branchName:this.branchList[0].assocLocMapId
        })
      }
    } else {
      this.selecetdAssociateCode=''
    }
  }
  associatesList:any=[]
  getAssociatesList(){
    let payload={
      "associateName":null,
      "locationName":null,
      "serviceId":["66"],
      "associateStatus":"ONB",
      "associateCode":null,
      "organizationCode":this.orgCode,
      "tenantCode":this.tenantCode
    }
      this.SpinnerService.hide()
    this.omsServiceService.getAssociatesList(payload).subscribe((res:any)=>{
      this.SpinnerService.hide()
      if (res.status == 'Success') {
        this.associatesList = res.dataObject.associates
      } else {
        this.toastr.error(res.reason)
      }
      
    })
  }
  selectedOfficer:any;
  onTenantOrgSearch(event: any) {
    let selectedData = event
    console.log(selectedData)
    if (selectedData != undefined && selectedData != null && selectedData != '') {
      this.selectedOfficer=selectedData
    } else {
      this.selectedOfficer={}
    }
  }

  resetLanguagesFilters(){

  }
  selectedLanguages:any=[]
  selectLanguage(event:any){
    event.map((data:any)=>{
      this.selectedLanguages.push(data.code)
    })
  }
  selectedQualification:any=[]
  selectQualification(event:any){
   this.selectedQualification=event
  }
  officerOnBoard(){
    let payload={
        "branchId": this.staff_Form.value.branchName,
        "associateId": this.selecetdAssociateCode,
        "organization_list": [
                "org__" + this.tenantCode + "_" + this.orgCode + "_1"
            ],
            "tenants_list": [
                "tenant_"+this.tenantCode
            ],
        "gender": this.staff_Form.value.gender,
        "officerRole": "PHO",
        "selectQualification": this.selectedQualification,
        "experience": this.staff_Form.value.yrExp,
        "firstName": this.staff_Form.value.firstName,
        "lastName": this.staff_Form.value.lastName,
        "mobile": this.staff_Form.value.mobile,
        "adharNo": "",
        "email": this.staff_Form.value.email,
        "dob": ""
    }
  }
  resetTeantFilters() {
    this.selectedOfficer={}
    // this.searchForm.patchValue({ 'selectedTenant': [], 'selectedOrg': [] });
    // this.organizationsOfTenants = []
  }
  remarksForAllocation='';
  submitForceAllocation(){
    let orders=[]
    this.orderId.map((details:any)=>{
      let data={}
      data["order_id"]=Number(details),
      data["associate_id"]=this.selectedOfficer.associate_code,
      data["branch_id"]= this.selectedOfficer.branch_id,
      data["reason"]=this.remarksForAllocation,
      data["officer_id"]=this.selectedOfficer.isp_code,
      data["officer_name"]=this.selectedOfficer.isp_name,
      data["officer_contact_number"]=this.selectedOfficer.isp_mobile_number
      orders.push(data)
    })
    let payload={
      "action" : 'OMS/api/operation.php/v1/bulkOrderAllocation',
      "type" : 'post',
      "actionById":window.localStorage.getItem('actionById'),
      "actionByName": window.localStorage.getItem('actionByName'),
      "orders":orders
    }
    this.omsServiceService.omsCommonMethod(payload).subscribe((res:any)=>{
        if(res.status==1){
          this.modal.close();
          this.toastr.success('Re-Allocation success..');
          setTimeout(function(){                          
            window.location.reload();
          }, 1000);
        }else{

        }
    })
  }
  getForceAllocationOffList(){
    let payload={
      "role_id": this.role,
      // "role_id":2,
      "tenant_code": this.tenantCode,
      "org_code": this.orgCode,
      "channel": "SDM",
      // "officer_name": "saddam" 
    }
    this.SpinnerService.show()
    this.omsServiceService.associatePortalCommonApi(payload).subscribe((res:any)=>{
      this.SpinnerService.hide()
        if(res.status == 1){
          this.ForceAllocationOffList=res.isp_list
        }
    })
  }
  openReAllocateData() {
    
    let omsorder_id = this.orderDetailsRes.order.patientinfo.order_id;
    let omsschedule_date = this.orderDetailsRes.order.patientinfo.scheduled_date;
    let omsworkorder_id = this.orderDetailsRes.wid;
    let omsassociateid = '';
    let omsbranchid = '';
    let omsapplication_no = '';
    let omsdelivery_lat = this.orderDetailsRes.order.patientinfo.delivery_lat;
    let omsdelivery_lng = this.orderDetailsRes.order.patientinfo.delivery_lng;
    let omspincode = this.orderDetailsRes.order.patientinfo.pincode;
    let omsis_continuous = this.orderDetailsRes.order.business.is_continuous;
    let omsorgCode = this.orderDetailsRes.orgCode;
    let omstenantCode = this.orderDetailsRes.tenantCode;
    let omsexistingOfficer = this.orderDetailsRes.order.order_status.assignedto;

    let dateTimesplit = omsschedule_date.split('.')
     dateTimesplit = dateTimesplit[0].split('T')
     omsschedule_date = dateTimesplit[0]+' '+dateTimesplit[1]

    let omsrole_id = (this.orderDetailsRes.order.provider_info.length == 1 ) ? this.orderDetailsRes.order.provider_info.role : 'loop';

    //  console.log(`orderDetailsRes`, this.orderDetailsRes[0])
     
     if (this.orderDetailsRes.active_component != "" && this.orderDetailsRes.active_component != null && this.orderDetailsRes.active_component != undefined) {
        this.orderDetailsRes.order.provider_info.forEach(i => {
            console.log(i.component_no)
            	if(i.component_no == this.orderDetailsRes.active_component)
              {
                omsrole_id = i.role;
              }
          })
			}
       let associatesRequest = {};
        associatesRequest["delivery_lat"] = omsdelivery_lat;
        associatesRequest["delivery_lng"] = omsdelivery_lng;
        associatesRequest["isInternalCall"] = 1;
        associatesRequest["orgCode"] = omsorgCode;
        associatesRequest["pincode"] = omspincode;
        associatesRequest["tenantCode"] = omstenantCode;
        associatesRequest["role_id"] = omsrole_id;
        associatesRequest["action"] = "OMS/api/operation.php/v1/fetch_nearby_associates";
        associatesRequest["type"] = "post";
        if( omsis_continuous != '1') // For continuous care plan orders, assoiate change cant be possible
        {
          this.omsServiceService.getNearbyAssociates(associatesRequest).subscribe(
          (res) => {
            this.assoc_data = res
            this.isAssocData = this.assoc_data["associates"];


          console.log(`fetch_nearby_associates`, this.assoc_data);
          })
        }
    /* Get Assoiates and branches near to delivery lat-lng End*/
        let officersRequest = {};
        officersRequest["scheduled_date"] = omsschedule_date;
        officersRequest["order_id"] = omsorder_id;
        officersRequest["isInternalCall"] = 1;
        officersRequest["roleType"] = omsrole_id;
        officersRequest["tenantOrgInfo"] = {"orgCode" : omsorgCode, "tenantCode" : omstenantCode};
        officersRequest["action"] = 'OMS/api/operation.php/v1/fetch_officers';
        officersRequest["type"] = 'post';

          this.omsServiceService.getNearbyOfficers(officersRequest).subscribe(
          (res) => {
            // this.officerAssocInfo = res;
            let officer_data = res
              officer_data.orderid = omsorder_id;
              officer_data.scheduled_date = omsschedule_date;
              officer_data.workorder_id = omsworkorder_id;		
              officer_data.existingOfficer = omsexistingOfficer;
              if( omsis_continuous != '1'){
              officer_data.assoc_data = this.assoc_data;
              }
              this.officerAssocInfo = officer_data;
              this.officerList = this.officerAssocInfo["data"];

          console.log(`fetch_nearby_officers`, this.officerAssocInfo);
          if (this.officerList == "" || this.officerList == null || this.officerList == undefined) {
            this.hideAllocateView = true;
        }else{
            this.officerList.forEach(officers=>{
            let selectedofficer = this.isorderDetailsRes
            if(officers.officer_id === selectedofficer.assaigned_to){
              officers.disabled = true
              console.log(`selected officer id`,selectedofficer.assaigned_to);
                  this.disableSelectBtn=true
              }else{
                officers.disabled = false
                  this.disableSelectBtn=false
              }
            })
        }
          })

  }
  
  getSubBranches(type: string) {
 
    this.branchInfo = this.assoc_data["assocBranches"][type]

      if(this.branchInfo.length > 0){
        this.issubCategory = true;
        this.isTableView = false;
      }
      console.log(`getSubBranches`,this.branchInfo)

  }

  getofficersList(){

      let dateTimesplit = this.orderDetailsRes.order.patientinfo.scheduled_date.split('.')
      dateTimesplit = dateTimesplit[0].split('T')
      let omsschedule_date = dateTimesplit[0]+' '+dateTimesplit[1]

      let officerRequest = {};
      officerRequest["order_id"] = this.orderDetailsRes.order.patientinfo.order_id;
      officerRequest["scheduled_date"] = omsschedule_date;
      officerRequest["workorder_id"] = this.orderDetailsRes.wid;
      officerRequest["associate_id"] = this.branchInfo[0].assoc_code;
      officerRequest["branch_id"] = this.branchInfo[0].branch_id;
      officerRequest["delivery_lat"] = this.orderDetailsRes.order.patientinfo.delivery_lat;
      officerRequest["delivery_lng"] = this.orderDetailsRes.order.patientinfo.delivery_lng;
      officerRequest["pincode"] = this.orderDetailsRes.order.patientinfo.pincode;
      officerRequest["roleType"] = 'loop';
      officerRequest["isInternalCall"] = 1;
      officerRequest["alternate_officers"] = 'Y';
      officerRequest["crossAllocateHelpBranch"] = 'Y';
      let omsorgCode = this.orderDetailsRes.orgCode;
      let omstenantCode = this.orderDetailsRes.tenantCode;
      officerRequest["existingOfficer"] = this.orderDetailsRes.order.order_status.assignedto;
      officerRequest["tenantOrgInfo"] = {"orgCode" : omsorgCode, "tenantCode" : omstenantCode};
      officerRequest["action"] = 'OMS/api/operation.php/v1/fetch_officers';
      officerRequest["type"] = 'post';

          this.omsServiceService.getNearbyOfficers(officerRequest).subscribe(
          (res) => {
            let officer_data = res
              officer_data.orderid = this.orderDetailsRes.order.patientinfo.order_id;
              officer_data.scheduled_date = omsschedule_date;
              officer_data.workorder_id = this.orderDetailsRes.wid;		
              officer_data.existingOfficer = this.orderDetailsRes.order.order_status.assignedto;
          console.log(`fetch_nearby_modal_officers`, officer_data);
            if(officer_data.status == 1){
              this.officerList = officer_data["data"]
              this.isTableView = true;
                this.officerList.filter(officer=>{
                  if(officer.officer_id === this.officerAssocInfo.officer_id){
                    officer.disabled = true
                  }else{
                    officer.disabled = false
                  }
                })
            }
          })
  }

  forceAllocation(Id,name,getSatatus){
    this.SpinnerService.show();

      if ((this.reasonType != "" && this.reasonType != null && this.reasonType != undefined && getSatatus == 're-allocate') || getSatatus == 'allocate') {
        // if (this.assocType != "" && this.assocType != null && this.assocType != undefined) {
        //   if (this.branchType != "" && this.branchType != null && this.branchType != undefined) {
            let reallocationRequest = {};
            reallocationRequest["allocated_by"] = 1;
            reallocationRequest["assigning_officer_id"] =  window.localStorage.getItem('actionById');
            reallocationRequest["assigning_officer_name"] = window.localStorage.getItem('actionByName');
            reallocationRequest["action"] = 'OMS/api/operation.php/v1/orderallocation';
            reallocationRequest["type"] = 'post';
            reallocationRequest["orders"] = [{"order_id" : this.orderDetailsRes.order.patientinfo.order_id, "associate_id" : this.assocType,"workorder_id" : this.orderDetailsRes.wid, "branch_id" : this.branchType,"officer_id" : Id, "officer_name" : name,"reason" : this.reasonType, "date_Changed" : false,"scheduled_date" : '', "isInternalCall" : 1}];

            console.log(`forceAllocation`,reallocationRequest)
            this.omsServiceService.forceAllocation(reallocationRequest).subscribe(
            (res) => {
                if (res["status"] == 1) {
                      // this.modal.close();
                      this.toastr.success('Re-Allocation success..');
                      setTimeout(function(){                          
                        window.location.reload();
                      }, 1000);
                } else {
                      // this.modal.close();
                      this.toastr.error('Something went wrong in allocation, please try again later..');
                }
              console.log(`forceAllocation_res`,res)
            })

        //   } else {
        //     this.toastr.error("please select branch");
        //   }
        // } else {
        //   this.toastr.error("please select associates");
        // }
    } else {
      this.toastr.error("please select reason type");
    }
    this.SpinnerService.hide();
  }

    reportComplete(){

      let orderRequest = {};
      orderRequest["order_id"] = this.orderDetailsRes.order.patientinfo.order_id;
      orderRequest["status"] = 6;
      orderRequest["isInternalCall"] = 1;
      orderRequest["reasonType"] = 1;
      orderRequest["source"] = "UCD Escaltion Dashboard";
      orderRequest["latitude"] = "";
      orderRequest["longitude"] = "";
      orderRequest["actionByName"] = window.localStorage.getItem('actionByName');
      orderRequest["actionById"] = window.localStorage.getItem('actionById');
      orderRequest["type"] = "post";
      orderRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
      
          this.omsServiceService.orderConfirmation(orderRequest).subscribe(
          (res) => {
            if (res["status"] == 1) {
              this.toastr.success(res["message"]);
            }else{
              this.toastr.error(res["message"]);
            }
            setTimeout(function(){                          
              window.location.reload();
            }, 2000);
          })
  }

  modelClose()
  {
    this.modal.close();
  }
  close()
  {
    this.modal.close();    
  }

}